var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallVelascaLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 188 188",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Velasca") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.997,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9 56.6c8.4-34.9 37-13.3 45.9-8.9 16.3 8.1 24.4 1.4 29.3-3.7 2.5-2.6 4.9-9.1 6.5-10.2 4.9-4.4.5 6.8.5 6.8-1.1 2.9-3.8 7.6-9 25.2-16.2 54.9-14.8 84.4-5.2 76.7 7.6-6.1 19-40.1 24.7-52.4 7.1-15 22.3-55.8 32.7-52.5 8.8 2.8-6.9 18.8-11.1 25.9-12.8 21.4-29.3 57.6-41.9 78.2-1.5 2.4-9.7 9.9-12.8.5-2.3-6.9-10.6-14.8 15-94.2.1-.3-1.4 1.7-1.3 1.4 0 0-12.2 8.5-28.4.4-8.9-4.5-31.3-24.2-39.8 10.8-8 32.9 17 30.8 36.4 18.7 7.6-4.7 7.9-10.7 13.2-8.6 5.3 2 .7 6.3-.9 7.5-11.2 8.8-64 31.7-54.6-18zM146.4 146c-3.8-3.5 1.5-6.9 6-5.2 4.5 1.8.9 6.1-.8 6.4-1.3.3-4.2-.3-5.2-1.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallVelascaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "small-velasca-logo.f9004d65161876bbe20878e4fc20e2de.svg";